<template>
  <div>
    <el-form :inline="true" :model="addSetting" label-width="160px">
      <el-row>
        <el-form-item label="Account Daily Cap" label-width="140px">
          <el-input
            v-model="addSetting.accountCapDaily"
            placeholder="write account daily cap.."
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="Conversion Daily Cap">
          <el-input
            v-model="addSetting.conversionCapDaily"
            placeholder="write conversion daily cap.."
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="All Offer Cap" label-width="140px">
          <el-input
            v-model="addSetting.sourceOfferCap"
            placeholder="write cap for all source offer.."
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <!-- 点击每日的Cap -->
        <el-form-item label="Click Daily Cap" label-width="130px">
          <el-input
            v-model="addSetting.clickCapDaily"
            placeholder="write Click Daily Cap"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="Offer Redirect Test" label-width="140px">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入内容"
            v-model="addSetting.description"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="Short Confusion" label-width="140px">
          <el-radio-group v-model="addSetting.isShortConfusion">
            <el-radio :label="0">不开启</el-radio>
            <el-radio :label="1">开启</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addSourceSetting">confirm</el-button>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="AffSub Decryption Confusion" label-width="200px">
          <el-input
            v-model="decryptAffSubVal"
            placeholder="write confusion affsub"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="decryptAffSub">Decrypt</el-button>
        </el-form-item>
        <!-- 上传 -->
        <el-form-item>
          <form
            :action="`/api/source/detail/decryptExcel/${id}`"
            target="_blank"
            method="post"
            enctype="multipart/form-data"
          >
            <input
              style="width:180px;margin-left: 5px;"
              @change="getFile"
              name="file"
              type="file"
            />
            <button type="submit" class="btn btn-primary">Download Excel</button>
          </form>
        </el-form-item>
      </el-row>
    </el-form>
  </div>
</template>

<script>
  import { addSourceSetting, getSourceSetting, decryptAffSub } from 'api/source/detail';
  const defaultSetting = {
    sourceId: '',
    accountCapDaily: '',
    conversionCapDaily: '',
    description: '',
    sourceOfferCap: '',
    clickCapDaily: '',
    isShortConfusion: 0,
  };
  export default {
    props: {
      id: {
        type: [String, Number],
        required: true,
      },
    },
    data() {
      return {
        decryptAffSubVal: '',
        addSetting: Object.assign({}, defaultSetting),
      };
    },
    mounted() {
      this.getSourceSetting();
    },
    methods: {
      getSourceSetting() {
        getSourceSetting(this.id).then((response) => {
          if (response.code === 200) {
            this.addSetting = response.result ?? Object.assign({}, defaultSetting);
          }
        });
      },
      addSourceSetting() {
        addSourceSetting({ ...this.addSetting, sourceId: this.id }).then((response) => {
          if (response.code == 200) {
            this.$message({
              message: 'Add Success',
              type: 'success',
            });
          } else {
            this.getSourceSetting();
            this.$message.error('Add Error:' + response.message);
          }
        });
      },
      decryptAffSub() {
        if (!this.decryptAffSubVal) {
          this.$message.warning('要先输入待解析的内容哦~');
        }
        decryptAffSub({
          sourceId: this.id,
          affSubConfusion: this.decryptAffSubVal,
        }).then((response) => {
          if (response.code === 200) {
            this.decryptAffSubVal = response.result;
          } else {
            this.$message.error('解析字符串失败啦');
          }
        });
      },
      getFile() {
        this.$message({
          message: '子渠道放在第一列',
          type: 'warning',
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .btn-primary {
    width: 120px;
    height: 40px;
    line-height: 40px;
    margin-left: 60px;
    border-radius: 4px;
    background: #409eff;
    color: #fff;
    border-color: #409eff;
  }
</style>
